import React, { createContext, useContext, useEffect, useState } from "react";
import { AxiosContext } from "./AxiosContext";
import { toast } from "react-toastify";

const UserContext = createContext();

export const useUser = () => {
  return useContext(UserContext);
};

export const useUserContext = () => useContext(UserContext);

export const UserProvider = ({ children }) => {
  const [users, setUsers] = useState([]);
  const { axiosInstance } = useContext(AxiosContext);
  const [cancelSubscriptionModalOpen, setCancelSubscriptionModalOpen] =
    useState(false);

  const fetchUsers = async () => {
    try {
      const { data } = await axiosInstance.get("/user-emails");
      setUsers(data.data);
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "failed to fetch users emails"
      );
    }
  };

  const forceCancelSubscription = async (username, options = {}) => {
    const { onSuccess } = options;
    try {
      await axiosInstance.put(
        `/user/${encodeURIComponent(username)}/cancel_subscription`,
        {}
      );
      toast.success("Subscription cancelled successfully");
      fetchUsers();
      if (typeof onSuccess === "function") {
        onSuccess();
      }
    } catch (error) {
      toast.error(
        error?.response?.data?.message || "failed to cancel subscription"
      );
    } finally {
      setCancelSubscriptionModalOpen(false);
    }
  };

  useEffect(() => {
    if (!axiosInstance) return;
    fetchUsers();

    return () => {};
  }, [axiosInstance]);

  return (
    <UserContext.Provider
      value={{
        users,
        fetchUsers,
        forceCancelSubscription,
        cancelSubscriptionModalOpen,
        setCancelSubscriptionModalOpen,
      }}
    >
      {children}
    </UserContext.Provider>
  );
};
